import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router';

import { ErrorPage } from './error-page';

export const RouteErrorBoundary = () => {
  const error = useRouteError();
  const isNotFound = isRouteErrorResponse(error) && error.status === 404;

  useEffect(() => {
    if (isNotFound) return;
    console.error('Route error:', error);
    Sentry.captureException(error);
  }, [error, isNotFound]);

  if (isNotFound) {
    return (
      <ErrorPage
        title="Page not found"
        description="Sorry, the page you are looking for does not exist."
        error={error}
      />
    );
  }

  return <ErrorPage error={error} />;
};
